import React, { useState, useRef } from 'react'
import styled from 'styled-components'

const VideoPlayerBlog = ({ webm, mp4, poster, className }) => {
  const videoEl = useRef()
  const [play, setPlay] = useState(false)

  const playVideo = () => {
    videoEl.current.play()
    setPlay(true)
  }

  return (
    <StyledVideo onClick={() => playVideo()} className={className}>
      <VideoPlayer
        disableRemotePlayback
        playsInline
        controls={play}
        ref={videoEl}
      >
        <source src={webm} type='video/webm' />
        <source src={mp4} type='video/mp4' />
      </VideoPlayer>
      <StyledImage hidden={play} src={poster} alt='poster' />
      <PlayIcon hidden={play}>
        <svg
          id='Capa_1'
          enableBackground='new 0 0 565.648 565.648'
          viewBox='0 0 565.648 565.648'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='m282.824 0c-155.947 0-282.824 126.877-282.824 282.824s126.877 282.824 282.824 282.824 282.824-126.877 282.824-282.824-126.877-282.824-282.824-282.824zm-70.706 424.233v-282.822l212.118 141.41z' />
        </svg>
      </PlayIcon>
    </StyledVideo>
  )
}

const StyledVideo = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  cursor: pointer;

  &:hover {
    svg {
      transform: scale(1.3);
    }
  }

  @media screen and (-ms-high-contrast: active) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}),
    screen and (-ms-high-contrast: none) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}) {
    overflow: hidden;
  }
`

const VideoPlayer = styled.video`
  object-fit: cover;
  height: 100%;
  width: 100%;

  /*&::-webkit-media-controls {
    display: none;
    -webkit-appearance: none;
  }*/

  @media screen and (-ms-high-contrast: active) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}),
    screen and (-ms-high-contrast: none) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}) {
    width: auto;
  }
`

const StyledImage = styled.img`
  object-fit: cover;
  height: 100%;
  width: 100%;
  position: absolute !important;
  top: 0;
  left: 0;
  display: ${(props) => (props.hidden ? 'none' : 'block')};
`

const PlayIcon = styled.div`
  display: ${(props) => (props.hidden ? 'none' : 'block')};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: scale(1) translate(-50%, -50%);

  svg {
    height: 20vw;
    width: 20vw;
    fill: ${(props) => props.theme.colors.blue};
    transition: transform 0.6s ${(props) => props.theme.easeOut.expo};

    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      height: 8vw;
      width: 8vw;
    }
  }
`

export default VideoPlayerBlog
